module.exports = __webpack_public_path__ + "media/images/tennis-pavilion-5efddb79.jpg";